import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M5 23.898c0 .63.5 1.258 1.25 1.258h5c.75 0 1.25-.629 1.25-1.258v-1.257H5zM8.75 0C3.875 0 0 3.9 0 8.805c0 3.018 1.5 5.66 3.75 7.17v2.892c0 .63.5 1.258 1.25 1.258h7.5c.75 0 1.25-.629 1.25-1.258v-2.893c2.25-1.635 3.75-4.276 3.75-7.17C17.5 3.9 13.625 0 8.75 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }